import { render, staticRenderFns } from "./XunJianRenYuan.vue?vue&type=template&id=421d235c&scoped=true&"
import script from "./XunJianRenYuan.vue?vue&type=script&lang=js&"
export * from "./XunJianRenYuan.vue?vue&type=script&lang=js&"
import style0 from "./XunJianRenYuan.vue?vue&type=style&index=0&id=421d235c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d235c",
  null
  
)

export default component.exports